import React from 'react'
import styles from "../vendorprofile/myprofile.module.css"
import VenPODetailsComp from '../../Components/orderscomp/VenPODetailsComp';
import VendorProfileMenu from '../../Components/vendorprofilemenu/VendorProfileMenu';

const VenPODetails = () => {
    return (
        <>
            <div className={styles.myprofile}>
                <div className={styles.promenu}>
                    <VendorProfileMenu />
                </div>
                    <VenPODetailsComp />
            </div>


        </>
    )
}

export default VenPODetails